import { getPdfRendererForSubmodel } from "./SubmodelPdfRegistry";
import getLocalizedText from "../../Utils";

function findSubmodelByIdShort(env, idShort) {
  return (env.submodels || []).find(sm => sm.idShort === idShort);
}

function resolveSubmodelPath(submodel, path) {
  if (!submodel || !path) return null;

  const parts = path.split(".");
  let current = submodel.submodelElements;

  for (const part of parts) {
    if (!current) return null;

    const element = current.find(e => e.idShort === part);
    if (!element) return null;

    // Step into COLLECTION if the element is a collection
    if (element.modelType === "SubmodelElementCollection" && element.value) {
      current = element.value;  // Move to the nested value (the array of elements inside the collection)
      continue;
    }

    // Found leaf node or property
    return element;
  }

  return null;
}

function renderProductImagePdf(builder) {
  try {
    const dummyImage = require("../../../assets/dummy_product_image.jpg");
    builder.image(dummyImage, {
      height: 60,
      width: 60,
    });

  } catch (err) {
    console.error("Failed to load dummy product image for PDF:", err);
    builder.textBlock("Product image unavailable.");
  }
}

function normalizeMLText(input) {
  // Already multi-language array?
  if (Array.isArray(input)) return input;

  // Simple string?
  if (typeof input === "string") {
    return [{ language: "en", text: input }];
  }

  // Fallback
  return null;
}

const PRODUCT_INFO_PROPERTIES = [
  { path: "ManufacturerProductType", key: "Manufacturer Product Type" },
  { path: "SerialNumber",          key: "Serial Number" },
  { path: "FirmwareVersion",       key: "Firmware Version" },
  { path: "HardwareVersion",       key: "Hardware Version" },
  { path: "YearOfConstruction",    key: "Year Of Construction" }
];

function extractProductInfo(builder, env) {
  const sm = findSubmodelByIdShort(env, "PublicInformation");
  if (!sm) return {};

  const result = {};

  for (const entry of PRODUCT_INFO_PROPERTIES) {
    const el = resolveSubmodelPath(sm, entry.path);
    if (!el) continue;

    // Normalize displayName (fallback to idShort if missing)
    const displayName = normalizeMLText(el.displayName) ||
                        normalizeMLText(el.idShort);

    // Normalize value (may be ML array or string)
    const value = normalizeMLText(el.value);

    if (value && displayName) {
      // Use the EN text as the map key (or a fallback)
      const key = getLocalizedText(displayName, entry.key, builder.locale);
      result[key] = value;
    }
  }

  return result;
}


function renderProductInfoPdf(builder, env) {
  const info = extractProductInfo(builder, env);

  builder.sectionHeader(builder.locale === 'de' ? "Produktübersicht" : "Product Overview");

  if (Object.keys(info).length === 0) {
    builder.textBlock("No product information available.");
    return;
  }

  const aas = env.assetAdministrationShells?.[0];
  const name = getLocalizedText(aas?.displayName, aas?.idShort || "N/A", builder.locale);
  const description = getLocalizedText(aas?.description, "N/A", builder.locale);
  builder.text("");  
  builder.text(name || "N/A");
  builder.keyValueRow("Beschreibung", description || "N/A");

  Object.entries(info).forEach(([label, value]) => {
    const labelLocalized = getLocalizedText(label, "N/A", builder.locale);
    const valueLocalized = getLocalizedText(value, "N/A", builder.locale);
    builder.keyValueRow(labelLocalized, valueLocalized);
  });
}

export async function renderAasEnvironment(builder, env) {
  //builder.title("Digitaler Produktpass");

  builder.columns(2, ({ col }) => {
    col(0).run(() => renderProductImagePdf(builder));
    col(1).run(() => renderProductInfoPdf(builder, env));
  });

  const submodels = env.submodels || [];

  submodels.forEach((submodel, index) => {
    const renderer = getPdfRendererForSubmodel(submodel);

    if (!renderer) {
      return;
    }

    builder.newPageIfNotFirst(index);
    renderer(builder, submodel);
  });
}
